<template>
  <VBtn @click="voltar"
        block>Cancelar
  </VBtn>
</template>

<script>
  export default {
    name: "BotaoCancelar",
    methods: {
      voltar() {
        return this.$router.go(-1);
      }
    }
  }
</script>

<style scoped>

</style>
